const colors = {
  WHITE: '#FFFFFF',
  WHITE_TXT: '#F5F7FA',
  BLACK: '#000000',
  PRIMARY_BLUE: '#0194d3',
  NAVY_BLUE: '#022d41',
  BRAND_BLUE: '#007EB4',
  DARKEST_NAVY_BLUE: '#01324DFF',
  DARKEST_GREY: '#535456',
  MEDIUM_GREY: '#6f6f6f',
  MEDIUM_GREY_V2: '#757575',
  LIGHT_GREY: '#d1d3d4',
  LIGHTER_GREY: '#f4f4f4',
  LOW_CONTRAST_GRAY: '#E1E6EA',
  LIGHTEST_GRAY: '#BABABA',
  PAGE_BACKGROUND: '#F6F7F9',
  GRAY_TXT: '#878F91',
  BLACK_TXT: '#283237',
  ICON_GREY: '#a3b4c7',
  DISABLED_GREY: '#8D8D8D',
  ORANGE: '#e98832',
  ORANGE_LIGHT: '#fcbb6d',
  GREEN: '#5a8126',
  GREEN_LIGHT: '#bad980',
  HOVER_BLUE: '#386e89',
  LIGHT_BLUE: '#e0f1f9',
  FADED_BLUE: '#b3dff2',
  FADED_ORANGE: '#fdd6a7',
  FADED_GREEN: '#d6e8b3',
  FADED_RED: '#ffbcbc',
  ERROR_RED: '#cf4647',
  RED_ERROR: '#FF0000',
  CELL_BLUE_1: '#B2DFF5',
  CELL_BLUE_2: '#DDF4FF',
  PLACEHOLDER_TEXT: '#DCDDDE',
  REJECTED: '#EB9C9C',
  PROCESSED: '#36B0E4',
  TRANSPARENT: 'rgba(0, 0, 0, 0)',
  HIGHLIGHT: '#EAF5FF',
  LIGHT_BLUE: '#2089BE',
  LIGHTER_BLUE: '#EDFAFF',
  DARK_BLUE: '#022D41',
  RED_PRIMARY: '#9C4242',
  BLUEISH_GREY: '#78909C'
};

export default colors;
